import type { AxiosResponse } from "axios";

import { logger } from "../../logging/logger";
import type { Interceptor } from "./interceptor";
import { describeDuration, describeRequest, responseSize, summarizeBody, summarizeHeaders } from "./net-log";
import { isLoggedUrl, netLogConfig } from "./net-log-config";

export const logResponseInterceptor: Interceptor<AxiosResponse> = {
  onFulfilled: (response) => {
    if (!netLogConfig.responses || !isLoggedUrl(response.config?.url)) {
      return response;
    }

    const parts = ["HTTP ←", `${response.status}`, describeRequest(response.config), describeDuration(response.config)];
    const size = responseSize(response);
    if (size) {
      parts.push(size);
    }
    if (netLogConfig.headers) {
      parts.push(`headers: ${summarizeHeaders(response.headers)}`);
    }
    if (netLogConfig.responseBody) {
      parts.push(`body: ${summarizeBody(response.data)}`);
    }
    logger.debug(...parts.filter(Boolean));

    return response;
  },
  onRejected: (error) => {
    if (!netLogConfig.errors || !isLoggedUrl(error?.config?.url)) {
      return Promise.reject(error);
    }

    const parts = [
      "HTTP ✗",
      `${error?.response?.status ?? error?.code ?? "no status"}`,
      error?.config ? describeRequest(error.config) : "",
      describeDuration(error?.config),
    ];
    if (netLogConfig.requestBody) {
      parts.push(`sent: ${summarizeBody(error?.config?.data)}`);
    }
    if (netLogConfig.errorBody) {
      parts.push(`received: ${summarizeBody(error?.response?.data)}`);
    }
    logger.debug(...parts.filter(Boolean));

    return Promise.reject(error);
  },
};
